<!-- 
Contents of the HISTORY tab of the role page.
-->
<template>
  <div>
    <our-heading 
      :next-page-action="nextPageAction"
      :previous-page-action="previousPageAction"
      :arrived-from-listing="arrivedFromListing"
      :breadcrumbs="breadcrumbs"
      :title="title"
      user-guide-topic="administration-roles-and-permissions"
      module="roles"
      nav-url="/roles/:id/history"
    />
    <tabs :role-id="roleId">
      <our-search-button 
        :criteria="criteria" 
        :criteria-mutation="criteriaMutation" 
        :search-filters="searchFilters" 
        title="Search role history"
        flat
        show-all
        @changed="$refs.history.refresh()"
      />
      <our-saved-searches-menu
        :criteria="criteria"
        :criteria-mutation="criteriaMutation"
        :clear-criteria-mutation="clearCriteriaMutation"
        module="systemLogs" 
        color="primary"
        flat dense
        @selected="$refs.history.refresh()"
      />
      <system-log-listing
        ref="history"
        :endpoint="`/api/roles/${roleId}/history`" 
        :export-endpoint="`/api/exports/roles/${roleId}/history`"
        :export-validate-endpoint="`/api/exports/validate/roles/${roleId}/history`"
        embedded 
      />
    </tabs>
  </div>
</template>

<script>
import SystemLogListing from "@/components/system-logs/SystemLogListing.vue";
import Tabs from "./Tabs.vue";
import roleMixins from "./mixins";
import * as mutation from "@/store/system-logs/mutation-types";
import { getSearchFilters } from "@/store/system-logs/helpers";

export default {
  name: "RoleSummary",
  components: { Tabs, SystemLogListing },
  mixins: [roleMixins],
  data() {
    return {
      criteriaMutation: mutation.LIST_SET_CRITERIA,
      clearCriteriaMutation: mutation.LIST_CLEAR_CRITERIA
    };
  },
  computed: {
    searchFilters() {
      return getSearchFilters("RoleAction", true);
    },
    criteria() {
      return this.$store.state.systemLogs.listing.criteria;
    }
  }
};
</script>
